import { render, staticRenderFns } from "./teachProcess.vue?vue&type=template&id=32383b22&scoped=true"
import script from "./teachProcess.vue?vue&type=script&lang=js"
export * from "./teachProcess.vue?vue&type=script&lang=js"
import style0 from "./teachProcess.vue?vue&type=style&index=0&id=32383b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32383b22",
  null
  
)

export default component.exports